<template>
    <div class="BuilderWrap">
        <!-- PDF文档列表 -->
        <div class="PDFList" v-if="pdfstate">
            <div class="LineCut1 flexbetween">
                <div class="NewsTitle flexa"><p>文档列表</p></div>
                <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
            </div>
            <div class="List">
                <ul>
                    <li v-for="(item,index) in pdflistdata" class="flexbetween" @click="OpenPdf(item.存档地址)" :key="index">
                        <p class="oneline">{{ item.标题 }}</p>
                        <p>{{ item.日期 }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 开发者编辑 -->
        <div class="PersonEditBox" v-if="EditState">
             <PersonEdit :Userid="this.LoginUserInfo.userId" :PersonData="PersonData" @Submit="Submit" @OpenEdit = "OpenEdit"></PersonEdit>
        </div>
        <!-- 我的主页 -->
        <div class="PersonIndexBox" :class="{'hidden':PersonState}">
            <MyIndex :PersonData="PersonData"  @OpenPersonBox="OpenPersonIndex" @OpenEdit="OpenEdit"></MyIndex>
        </div>
<!--        <div class="ReadWrap">
          <div class="VedioWrap flexbetween">
              <div class="Vedio"><img src="../../assets/Home/vedio.jpg"></div>
              <div class="VedioList">
                 NewsWrap  <div class="ListNav flexa">
                      <div class="flexa active nav1"><img src="../../assets/Home/k1.png"><p>在线学习</p></div>
                      <div class="flex nav2"><img src="../../assets/Home/k2.png"><p>资料下载</p></div>
                      <div class="flexa nav3"><div class="flex"><img src="../../assets/Home/k3.png"><p>培训活动</p></div></div>
                  </div>
                  <div class="ListContent">
                      <ul>
                          <li class="flexbetween"><p>毕向东java基础教程</p><p>2019.11.23 上传整理</p></li>
                          <li class="flexbetween"><p>Python基础视频教程</p><p>2019.10.12 上传整理</p></li>
                          <li class="flexbetween"><p>JavaScript基础教程</p><p>2019.09.25 上传整理</p></li>
                          <li class="flexbetween"><p>C++零基础视频教程</p><p>2019.09.21 上传整理</p></li>
                          <li class="flexbetween"><p>Go语言基础视频教程</p><p>2019.08.14 上传整理</p></li>
                          <li class="flexbetween"><p>5天玩转MySQL</p><p>2019.08.13 上传整理</p></li>
                      </ul>
                  </div>
                  <div class="Page flexa">
                      <div class="flex PageNum">
                          <div class="LastPage">上一页</div>
                          <div class="flex"><span>1</span><span class="active">2</span><span>3</span><span>4</span></div>
                          <div class="NextPage">下一页</div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="MoreWrap flexbetween">
              <div class="LeftContent">
                  <div class="Title flexbetween">
                      <div class="flex"><img src="../../assets/Home/k4.png"><p>知识库</p></div>
                      <div class="flex"><img src="../../assets/Home/k5.png"><p>查看全部</p></div>
                  </div>
                  <div class="ListContent">
                      <ul>
                          <li class="flexbetween"><p>毕向东java基础教程</p><p>2019.11.23 上传整理</p></li>
                          <li class="flexbetween"><p>Python基础视频教程</p><p>2019.10.12 上传整理</p></li>
                          <li class="flexbetween"><p>JavaScript基础教程</p><p>2019.09.25 上传整理</p></li>
                          <li class="flexbetween"><p>C++零基础视频教程</p><p>2019.09.21 上传整理</p></li>
                          <li class="flexbetween"><p>Go语言基础视频教程</p><p>2019.08.14 上传整理</p></li>
                          <li class="flexbetween"><p>5天玩转MySQL</p><p>2019.08.13 上传整理</p></li>
                          <li class="flexbetween"><p>JavaScript基础教程</p><p>2019.09.25 上传整理</p></li>
                      </ul>
                  </div>
              </div>
              <div class="RightContent">
                  <div class="Title flexbetween">
                      <div class="flex"><img src="../../assets/Home/k6.png"><p>问答</p></div>
                      <div class="flex"><img src="../../assets/Home/k5.png"><p>查看全部</p></div>
                  </div>
                  <div class="ListContent">
                      <ul>
                          <li class="flexbetween"><p>毕向东java基础教程</p><p>2019.11.23 上传整理</p></li>
                          <li class="flexbetween"><p>Python基础视频教程</p><p>2019.10.12 上传整理</p></li>
                          <li class="flexbetween"><p>JavaScript基础教程</p><p>2019.09.25 上传整理</p></li>
                          <li class="flexbetween"><p>C++零基础视频教程</p><p>2019.09.21 上传整理</p></li>
                          <li class="flexbetween"><p>Go语言基础视频教程</p><p>2019.08.14 上传整理</p></li>
                          <li class="flexbetween"><p>JavaScript基础教程</p><p>2019.09.25 上传整理</p></li>
                          <li class="flexbetween"><p>5天玩转MySQL</p><p>2019.08.13 上传整理</p></li>
                      </ul>
                  </div>
              </div>
          </div>
        </div>-->
        <div class="SwiperWrap">
            <i class="LeftShadow hidden"><img src="../../assets/Home/LeftShadow.png"></i>
            <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/b-3.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/b-4.jpg"></swiper-slide>
                <div class="swiper-pagination flex" slot="pagination"></div>
            </swiper>
            <i class="RightShadow hidden"><img src="../../assets/Home/RightShadow.png"></i>
        </div>
        <div class="NewsWrap flexbetween">
            <div class="NewsList">
                <div class="NewsTitle">
                    <p>LEARNING <span>DOWNLOAD</span></p>
                </div>
                <div class="ListWrap">
                    <ul>
                        <li v-for="(item,index) in pdflistdata1" class="flexbetween" @click="OpenPdf(item.存档地址)" :key="index">
                            <p class="oneline">{{ item.标题 }}</p>
                            <p>{{ item.日期 }}</p>
                        </li>
                    </ul>
                </div>
                <div class="MoreNews" @click="OpenPDFList"><p>more...</p></div>
            </div>
            <div v-if="(this.typestate===0)" class="NewsImg"   @click="OpenPersonIndex"><img src="../../assets/Home/build1.png"></div>
            <div v-else-if="(this.typestate===1)" class="NewsImg"><img src="../../assets/Home/build2.png"></div>
            <div v-else-if="(this.typestate===-1)" class="NewsImg" @click="Join"><img src="../../assets/Home/build3.png"></div>
            <div v-else class="NewsImg" @click="Join"><img src="../../assets/Home/build.png"></div>
        </div>
      <!--  <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>DEVELOPER <span>LIST</span></p></div>
            <div class="Return flexa"><p>查看全部</p></div>
        </div>-->
      <!--  <div class="JoinWrap">
            <div class="Text">
                <p>开发者社区</p>
                <p class="twoline">当你选择了一种语言,意味着你还选择了一组技术、一个社区...</p>
            </div>
            <div class="Button flex">进入社区</div>
        </div>-->
        <!-- 购买开发者 -->
        <div class="BuyBox" :class="{'hidden':Active}">
            <div class="Login">
                <div class="LoginContentWrap">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 请注册...</p></div>
                    <div class="CloseBox" @click="close"><img src="../../assets/Home/exit1.png"></div>
                    <div class="InputWrap">
                        <div class="RadioWrap flexa">
                            <div class="RadioTitle">注册为</div>
                            <!-- @click="ChangeType(index,item)"-->
                            <div  v-for="(item,index) in this.ItemList" :key="index" class="flexa Radio">
                                <div class="flex"><i :class="{'hidden':Listflag!=index}"></i></div>
                                {{ item.名称 }}
                            </div>
                        </div>
                        <!-- 个人开发者 -->
                        <div v-if="(type=='001')" class="InputListWrap">
                            <div class="InputContent flexa">
                                <div class="InputTitle">联系人</div>
                                <div class="Input"><p>{{ this.LoginUserInfo.username }}</p></div>
                            </div>
                            <div class="InputContent flexa">
                                <div class="InputTitle">联系方式</div>
                                <div class="Input"><p>{{ this.LoginUserInfo.tel }}</p></div>
                            </div>
                        </div>
                        <!-- 企业开发者 -->
                        <div v-else-if="(type=='002')" class="InputListWrap">
                            <div class="InputContent flexa">
                                <div class="InputTitle">认证企业</div>
                                <div class="Input SelectWrap flexa">
                                    <select v-model="submitdata.ChooseComponey" v-if="Componey.length>0" autocomplete="off"  @change="Savename($event)">
                                        <option v-for="(item,index) in Componey" :key="index" :value="item.编码">{{ item.名称 }}</option>
                                      <!--  <option value="004">123</option>-->
                                    </select>
                                    <p v-else style="font-size: 14px;color: #b1b1b1;margin-left: 10px">企业未认证</p>
                                </div>
                                <!--<p class="AddCompaney" @click="OpenSenchaBox('authentication')">+认证企业</p>-->
                              <p class="AddCompaney hidden" @click="ToCenter">+认证企业</p>
                            </div>
                            <div class="InputContent flexa">
                                <div class="InputTitle">联系人</div>
                                <div class="Input"><p>{{ this.LoginUserInfo.username }}</p></div>
                            </div>
                            <div class="InputContent flexa">
                                <div class="InputTitle">联系方式</div>
                                <div class="Input"><p>{{ this.LoginUserInfo.tel }}</p></div>
                            </div>
                        </div>
                        <!-- 体验用户 -->
                        <div v-else class="InputListWrap">
                            <div class="InputContent flexa">
                                <div class="InputTitle">联系人</div>
                                <div class="Input"><p>{{ this.LoginUserInfo.username }}</p></div>
                            </div>
                            <div class="InputContent flexa">
                                <div class="InputTitle">联系方式</div>
                                <div class="Input"><p>{{ this.LoginUserInfo.tel }}</p></div>
                            </div>
                        </div>
                        <div class="ChooseWrap">
                            <div class="RadioWrap flexa">
                                <div class="RadioTitle">注册说明</div>
                            </div>
                            <div class="ItemList">
                                <ul>
                                    <!-- @click="ChooseItem(item,index)"-->
                                    <li v-for="(item,index) in ItemData" :key="index">
                                        <div class="flexa Radio">
                                           <!-- <div class="flex ChooseFlag"><i :class="{'hidden':flag!=index}"></i></div>-->
                                            <div class="Name">{{ item.名称 }}</div>
                                          <!--  <div class="Price">￥ {{ item.收费标准}}</div>
                                            <div class="Date">{{ item.有效期}}</div>-->
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="Submit flexbetween">
                            <div class="Text flexa">注册即代表您同意 <span  @click="OpenUrl('https://www.goeasy.cn/pass.html')">《工易PaaS平台服务协议》</span></div>
                            <div @click="submit" class="flex Button">注册</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" :class="{'hidden':ActiveBuy}">
            <div class="Login">
                <div class="LoginContentWrap">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 请支付...</p></div>
                    <div class="CloseBox" @click="close1"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div class="CodeWrap">
                       <img :src="code">
                    </div>
                    <div class="flex Tip"><p>请使用微信扫描二维码支付</p></div>
                    <div class="flex ReButton" @click="ReloadTip">支付成功后点击刷新</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import axios from 'axios';
  import PersonEdit from '../../components/PersonEdit';
  import MyIndex from '../../components/MyIndex';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'builder',
    components: {
      MyIndex,
      PersonEdit
    },
    inject: [
      'load'
    ],
    data() {
      return {
        pdflistdata: [],
        pdflistdata1: [],
        pdfstate: false,
        PersonData: {
          Name: '',
          Items: '',
          Time: '',
          Email: '',
          Type: '',
          Phone: '',
          Head: '',
          Info: ''
        },
        EditState: false,
        CheckState: false,
        typestate: 2,
        savename: '',
        PersonState: 'true',
        submitdata: {
          UserName: '',
          UserPhone: '',
          ChooseType: '',
          ChooseComponey: '',
          ChooseBuyType: '008',
          token: ''
        },
        PayId: '',
        Active: 'true',
        ActiveBuy: 'true',
        code: '',
        ItemList: [],
        BuyTypes: {},
        Componey: [],
        ItemData: [],
        flag: '0',
        Listflag: '0',
        type: '002',
        swiperOptions: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 0,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        }
      };
    },
    methods: {
      ToCenter() {
        this.$router.push({
          name: 'PersonCenter'
        });
      },
      GetPdfList() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007047',
            userId: 'CommonUser_ixuOYxkPy78='
          }
        }).then(res => {
          console.log(res);
          if (res.data.code === 0) {
            this.pdflistdata = res.data.data.DETAIL;
            this.pdflistdata1 = res.data.data.DETAIL.slice(0, 6);
          } else {
            this.$message.error(res.data.msg);
          }
          this.load.hide();
        }).catch(error => {
          this.load.hide();
          this.$message.error(error);
          console.log(error);
        });
      },
      OpenPDFList() {
        this.pdfstate = true;
      },
      Return() {
        this.pdfstate = false;
      },
      ...mapActions(['getUserInfo']),
      OpenPdf(url) {
        window.open(url, '_blank');
      },
      Savename(e) {
        this.savename = this.Componey[e.target.selectedIndex].名称;
        console.log(this.savename);
      },
      /* 提交修改数据 */
      Submit(data) {
        console.log(data);
        this.load.show();
        axios({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          url: `${this.$builderUrl}/third/sethomeinfo`,
          data: {
            token: this.LoginUserInfo.userId,
            Name: data.Name,
            Items: data.Items.toString(),
            Phone: data.Phone,
            Email: data.Email,
            Head: data.Head,
            Info: data.Info
          }
        }).then(res => {
          if (res.data.code === 0) {
            this.GetMyData();
          } else {
            this.load.hide();
          }
        }).catch(error => {
          console.log(error);
          this.load.hide();
        });
      },
      OpenEdit() {
        this.EditState = !this.EditState;
      },
      OpenUrl(url) {
        window.open(url, '_blank');
      },
      /* 获取个人主页信息 */
      GetMyData() {
        axios({
          method: 'GET',
          url: `${this.$builderUrl}/third/gethomeinfo`,
          params: {
            token: this.LoginUserInfo.userId,
            id: ''
          }
        }).then(res => {
          console.log(res);
          if (res.data.code === 0) {
            let _res = res.data.data;
            console.log(res.data.data);
            this.PersonData.Name = _res.名称;
            this.PersonData.Info = _res.简介;
            this.PersonData.Head = _res.头像;
            if (_res.标签 !== '') {
              this.PersonData.Items = _res.标签.split(',');
            } else {
              this.PersonData.Items = [];
            }
            this.PersonData.Phone = _res.电话;
            this.PersonData.Email = _res.邮箱;
            this.PersonData.Time = _res.截止日期;
            this.PersonData.Type = _res.套餐类型;
            this.load.hide();
            this.EditState = false;
          }
        }).catch(error => {
          console.log(error);
        });
      },
      OpenPersonIndex() {
        this.GetMyData();
        this.PersonState = !this.PersonState;
      },
      /* 判断是否已经注册过开发者 */
      CheckUser() {
        this.load.show();
        axios({
          method: 'GET',
          url: `${this.$builderUrl}/third/devcheckreg`,
          params: {
            token: this.LoginUserInfo.userId
          }
        }).then(res => {
          console.log('判断用户是否注册过', res);
          if (res.data.code === 0) {
            this.load.hide();
            this.typestate = 0;
          } else if (res.data.code === 1) {
            this.load.hide();
            this.typestate = 1;
            /*  alert('审批中'); */
          } else if (res.data.code === -1) {
            this.typestate = -1;
            this.load.hide();
            /*     alert('拒绝'); */
          } else if (res.data.code === 2) {
            this.typestate = 2;
            this.load.hide();
          }
        }).catch(error => {
          this.load.hide();
          console.log(error);
        });
      },
      /* 认证弹窗 */
      OpenSenchaBox(val) {
        // debugger;
        this.close();
        this.$store.dispatch('setplatformname', 'SaaS平台');
        if (this.LoginUserInfo.userId) {
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: val, code: this.currentSystem.code, name: this.currentSystem.name });
        }
      },
      /* 点击支付成功按钮 */
      ReloadTip() {
        this.load.show();
        axios({
          method: 'GET',
          url: `${this.$builderUrl}/third/devregcheckpay`,
          params: {
            token: this.LoginUserInfo.userId,
            payid: this.PayId
          }
        }).then(res => {
          console.log(res);
          if (res.data.code === 0) {
            this.load.hide();
            this.$alert('您已成功注册工易开发用户，请您在开发者-我的主页中完善资料信息，登录首页建模平台开启您的开发之旅！', '支付成功', {
              confirmButtonText: '确定',
              callback: res => {
                this.close();
                this.CheckState = true;
                this.ActiveBuy = !this.ActiveBuy;
                this.getUserInfo();
              }
            });
          } else {
            this.load.hide();
            this.$alert('尚未查询到您的有效支付信息,请您核对支付记录确认是否支付成功,如已支付成功,请截图发送至lansr@goeasy.cn，我们将与您联系处理！', '支付失败', {
              confirmButtonText: '确定'
              /*   callback: action => {
                this.$message({
                  type: 'info',
                  message: `action: ${ action }`
                });
              } */
            });
          }
        }).catch(error => {
          console.log(error);
          this.$alert('服务器繁忙,请稍后再试！', '异常！', {
            confirmButtonText: '确定'
            /*   callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${ action }`
              });
            } */
          });
        });
      },
      /* 审批注册 */
      /*      Check(name) {
        console.log(name);
      }, */
      Check(name) {
        axios.post(`${this.$baseUrl}Web_OnClickButtonOfBill`, {
          commandId: 'WBA0007002',
          buttonText: 'Verify',
          userId: 'GoeasyUser' + this.LoginUserInfo.userId,
          headData: {
            企业信息: this.submitdata.ChooseComponey,
            开发账户类型: this.submitdata.ChooseType,
            开发服务费标准: this.submitdata.ChooseBuyType,
            联系方式: this.submitdata.UserPhone,
            联系人: this.submitdata.UserName,
            名称: name
          }
        }).then(res => {
          console.log(res);
          this.load.hide();
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error);
          this.load.hide();
        });
      },
      /* 注册提交 */
      /*      submit() {
        console.log(this.savename);
        let name = '';
        if (this.type === '002') {
          name = this.savename;
        } else {
          name = this.LoginUserInfo.username;
        }
        this.Check(name);
      }, */
      submit() {
        /* 认证判断，拿掉了，不一定啥时候又要，留着别删 */
/*        if (this.LoginUserInfo.realname === '') {
          this.$confirm('您的账号未认证, 无法注册,您可以点击下方"去认证"按钮进行认证，或者稍后去个人中心"GE认证平台"进行认证。', '提示', {
            confirmButtonText: '去认证',
            cancelButtonText: '知道了',
            type: 'warning'
          }).then(() => {
            this.OpenSenchaBox('authentication');
          }).catch(() => {
            console.log('取消了注册');
          });
        } else */if (this.Componey.length === 0 && this.type === '002') {
          this.$confirm('您还没有进行企业认证，请到个人中心-认证平台进行企业认证', '提示', {
            confirmButtonText: '去认证',
            cancelButtonText: '知道了',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              name: 'PersonCenter'
            });
          }).catch(() => {
            console.log('取消了注册');
          });
        } else {
          this.load.show();
          this.submitdata.UserName = this.LoginUserInfo.username;
          this.submitdata.UserPhone = this.LoginUserInfo.tel;
          let com = '';
          for (let i in this.Componey) {
            if (this.Componey[i].编码 === this.submitdata.ChooseComponey) {
              com = this.Componey[i].名称;
            }
          }
        axios.post('https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill', {
            commandId: 'WBA0007002',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            saveGridData: 1,
            headData: {
              名称: com,
              企业信息: this.submitdata.ChooseComponey,
              开发者类型: this.submitdata.ChooseType,
              开发服务费标准: this.submitdata.ChooseBuyType,
              联系人: this.submitdata.UserName,
              联系方式: this.submitdata.UserPhone,
              用户编码: this.LoginUserInfo.goeasyid
            }
          }).then(res => {
            console.log(res, res.data.code, res.data.msg);
            if (res.data.code === 0) {
              // eslint-disable-next-line no-unused-vars
                let name = '';
                if (this.type === '002') {
                  name = this.savename;
                } else {
                  name = this.submitdata.UserName;
                }
                // this.Check(name);
                this.$alert('开发者注册申请已提交！', '提示', {
                  confirmButtonText: '确定',
                  callback: res => {
                    this.close();
                    this.load.hide();
                    this.getUserInfo();
                    this.typestate = 1;
                  }
                });
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          }).catch(error => {
            this.$message.error('请求错误!');
            console.log(error);
            this.load.hide();
          });
        }
      },
      /* 更改开发类型 */
      ChangeType(flag, data) {
        this.Listflag = flag;
        this.flag = '0';
        this.type = data.编码;
        if (this.type === '001') {
          this.ItemData = this.BuyTypes['001'];
          this.submitdata.ChooseComponey = '';
          this.savename = '';
        } else if (this.type === '002') {
          this.ItemData = this.BuyTypes['002'];
          this.submitdata.ChooseComponey = this.Componey[0].编码;
          this.savename = this.Componey[0].名称;
        } else {
          this.ItemData = this.BuyTypes['003'];
          this.submitdata.ChooseComponey = '';
          this.savename = '';
        }
        this.submitdata.ChooseType = data.编码;
        this.submitdata.ChooseBuyType = this.ItemData[0].编码;
      },
      /* 更改付费类型 */
      ChooseItem(data, flag) {
        this.flag = flag;
        this.submitdata.ChooseBuyType = data.编码;
        console.log(data);
      },
      Join() {
        if (this.LoginUserInfo.userId === undefined) {
          this.$emit('OpenLoginBox');
        } else {
          this.submitdata.token = this.LoginUserInfo.userId;
          this.GetData();
        }
      },
      /* 获取套餐数据 */
      GetData() {
        axios.get(`${this.$builderUrl}/third/getreginfo?token=${this.LoginUserInfo.userId}`, {}).then(res => {
          console.log(res.data.data);
          this.Active = !this.Active;
          this.ItemList = res.data.data.开发者类型;
          this.BuyTypes = res.data.data.收费标准;
          this.Componey = res.data.data.注册企业;
          /*  默认显示001组收费标准 */
          this.ItemData = res.data.data.收费标准['002'];
          /* 默认提交的数据 */
          this.submitdata.ChooseType = this.ItemList[0].编码;
          this.submitdata.ChooseBuyType = this.ItemData[0].编码;
          this.savename = this.Componey[0].名称;
          if (this.type === '002') {
            this.submitdata.ChooseComponey = res.data.data.注册企业[0].编码;
          }
        }).catch(error => {
          console.log(error);
        });
      },
      /* 关闭选择 */
      close() {
        /* 初始化选项为第一个 */
        this.flag = '0';
        this.Listflag = '0';
        this.type = '002';
        this.Active = !this.Active;
      },
      close1() {
        /* 首先判断是否支付成功 */
        axios({
          method: 'GET',
          url: `${this.$builderUrl}/third/devregcheckpay`,
          params: {
            token: this.LoginUserInfo.userId,
            payid: this.PayId
          }
        }).then(res => {
          console.log(res);
          if (res.data.code === 0) {
            this.$alert('您已成功注册工易开发用户，请您在开发者-我的主页中完善资料信息，登录首页建模平台开启您的开发之旅！', '支付成功', {
              confirmButtonText: '确定',
              callback: res => {
                this.close();
                this.CheckState = true;
                this.ActiveBuy = !this.ActiveBuy;
                this.getUserInfo();
              }
            });
          } else {
            /* 未支付 */
            this.$confirm('尚未查询到您的有效支付信息,请您核对支付记录确认是否支付成功,如已支付成功,请截图发送至lansr@goeasy.cn，我们将与您联系处理！', '提示', {
              confirmButtonText: '仍要关闭',
              cancelButtonText: '我知道了',
              type: 'warning'
            }).then(() => {
              this.close();
              this.ActiveBuy = !this.ActiveBuy;
            }).catch(() => {
              console.log('取消了支付');
            });
          }
        }).catch(error => {
          console.log(error);
          this.$alert('服务器繁忙,请稍后再试！', '异常！', {
            confirmButtonText: '确定'
            /*   callback: action => {
                this.$message({
                  type: 'info',
                  message: `action: ${ action }`
                });
              } */
          });
        });
      }
    },
    /* 监听登录信息，因为第一次进来可能没有登录，此时点击加入开发者弹出登录，登录完毕后需要验证是否注册过 */
    watch: {
      LoginUserInfo: function (val, oldVal) {
        if (val !== oldVal) {
          this.CheckUser();
        }
      }
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'currentSystem'])
    },
    created() {
      this.GetPdfList();
      /*  每次进入页面判断该用户是否注册过开发者，如果注册过则注册入口改为维护入口  */
      if (this.LoginUserInfo.userId !== undefined) {
        this.CheckUser();
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import '../../../public/Value';
    .PDFList{
        width: 50%;
        height:calc(100% - 0.8rem);
        top:0.8rem;
        left: 25%;
        position: fixed;
        z-index: 5;
        background-color: #000;
        overflow-y: scroll;
        &::-webkit-scrollbar{
            display: none;
        }
        .LineCut1{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .List{
            width: 88%;
            margin-left: 7%;
            margin-top: 0.1rem;
            ul{
                width: 100%;
                li{
                    width: 100%;
                    font-size: $TextSize;
                    color: #fff;
                    border-bottom: 1px solid rgba(255,255,255,0.7);
                    padding: 0.05rem 0;
                    margin-bottom: 0.05rem;
                    cursor: pointer;
                    p:first-child{
                        opacity: 1;
                    }
                    p:last-child{
                        font-size: $AdditionTextSize;
                        margin-right: 5px;
                        opacity: 0.8;
                    }
                }
            }
        }
    }
    .PersonEditBox, .PersonIndexBox{
        width: 46%;
        height: calc(100% - 0.7rem);
        position: fixed;
        left: 27%;
        bottom: 0;
        z-index: 4;
    }
    .PersonEditBox{
        z-index: 5;
    }
    .Login {
        .InputWrap{
            width: 90%;
            margin: 0.15rem auto 0;
            height: 88%;
            position: relative;
            .Submit{
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                .Button{
                    width: 0.5rem;
                    height: 0.15rem;
                    border-radius: 0.3rem;
                    background-color: #fff;
                    cursor: pointer;
                    box-shadow: 5px 5px 15px #47478c;
                    font-size: $TextSize;
                    color: #4848b8;
                }
                .Text{
                    font-size: $TextSize;
                    color: #fff;
                    height: 0.15rem;
                    span{
                        font-size: $AdditionTextSize;
                        opacity: 0.7;
                        cursor: pointer;
                    }
                }
            }
            .InputListWrap{
                width: 100%;
                border-bottom: 4px solid #fff;
                padding-bottom: 0.12rem;
                .AddCompaney{
                    font-size: $TextSize;
                    color: #2ca7ff;
                    margin-left: 0.05rem;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .InputContent{
                width: 100%;
                margin-top: 0.08rem;
                .InputTitle{
                    width: 0.5rem;
                    font-size: $TextSize;
                    color: #fff;
                }
                .SelectWrap{
                    width: 1.5rem;
                    height: 0.15rem;
                    background-color: #fff;
                    border-radius: 0.3rem;
                    font-size: $TextSize;
                    select{
                        width: 1.4rem;
                        height: 0.15rem;
                        font-size: $TextSize;
                        margin-left: 0.05rem;
                    }
                }
                .Input{
                    p{
                        font-size: $TextSize;
                        color: #fff;
                    }
                }
            }
            .RadioWrap{
                width: 100%;
                height: 0.2rem;
                .RadioTitle{
                    width: 0.5rem;
                    font-size: $TitleSize;
                    font-weight: bold;
                    color: #fff;
                }
                .Radio{
                    font-size: $TextSize;
                    color: #fff;
                    margin-right: 0.1rem;
                    div{
                        width: 0.07rem;
                        height: 0.07rem;
                        border-radius: 0.1rem;
                        background-color: #fff;
                        margin-right: 0.05rem;
                        cursor: pointer;
                        i{
                            width: 0.04rem;
                            height: 0.04rem;
                            background-color: #666666;
                            border-radius: 0.04rem;
                        }
                    }
                    @media screen and(max-width: 1930px) {
                        div{
                            width: 20px;
                            height: 20px;
                            border-radius:20px;
                            background-color: #fff;
                            margin-right: 0.05rem;
                            cursor: pointer;
                            i{
                                width: 12px;
                                height: 12px;
                                background-color: #666666;
                                border-radius: 12px;
                            }
                        }
                    }
                }
            }
            .ChooseWrap{
                width: 100%;
                margin-top: 0.05rem;
                border-bottom: 4px solid #fff;
       /*         padding-bottom: 0.08rem;*/
                .ItemList{
                    width: 83%;
                    margin-left: 16%;
                    margin-top: 0.07rem;
                    ul{
                        width: 100%;
                        li{
                            width: 100%;
                            height: 0.12rem;
                            margin-bottom: 0.05rem;
                            border-bottom: 4px solid rgba(255,255,255,0.6);
                            .Date{
                                width: 0.63rem;
                            }
                            .Name{
                                width: 1.42rem;
                                text-align: left;
                            }
                            @media screen and(max-width: 1500px) {
                                .Name{
                                    width:1.58rem;
                                    text-align: left;
                                }
                            }
                            .Price{
                                width: 0.44rem;
                                text-align: left;
                            }
                            .Date{
                                text-align: right;
                            }
                            .Radio{
                                font-size: $TextSize;
                                color: #fff;
                                .ChooseFlag{
                                    width: 0.07rem;
                                    height: 0.07rem;
                                    border-radius: 0.1rem;
                                    background-color: #fff;
                                    margin-right: 0.05rem;
                                    cursor: pointer;
                                    i{
                                        width: 0.04rem;
                                        height: 0.04rem;
                                        background-color: #666666;
                                        border-radius: 0.05rem;
                                    }
                                }
                                @media screen and(max-width: 1930px) {
                                    .ChooseFlag{
                                        width: 20px;
                                        height: 20px;
                                        border-radius:20px;
                                        background-color: #fff;
                                        margin-right: 0.05rem;
                                        cursor: pointer;
                                        i{
                                            width: 12px;
                                            height: 12px;
                                            background-color: #666666;
                                            border-radius: 12px;
                                        }
                                    }
                                }
                            }
                        }
                        li:last-child{
                            border-bottom: none;
                        }
                    }
                }
            }
        }
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 4;
        display: flex;
        -webkit-justify-content: center;
        -webkit-align-items: center;
        .LoginContentWrap {
            width: 2.7rem;
            height: 2.78rem;
            border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
            background: linear-gradient(to bottom right, #6666cc, #4141b3);
            position: relative;
            .CloseBox {
                width: 0.15rem;
                height: 0.15rem;
                position: absolute;
                cursor: pointer;
                right: 0.05rem;
                top: 0.05rem;
                z-index: 4;

                img {
                    width: 100%;
                }
            }
            .NeedKnown {
                position: absolute;
                width: 100%;
                bottom: 0.1rem;

                p {
                    font-size: $SmallTextSize;
                    color: #fff;
                    text-align: center;

                    span {
                        cursor: pointer;
                        font-weight: bold;
                        margin: 0 0.02rem;
                        color: #999900;
                    }
                }
            }
            .LoginTitle {
                width: 100%;
                margin-top: 0.05rem;

                p {
                    font-size: $TextSize;
                    color: #fff;
                    text-indent: 0.05rem;
                }
            }
        }
    }
    .BuilderWrap{
        .pdfwrap{
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 2;
        }
        width: 100%;
        position: relative;
        .BuyBox{
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 4;
            .ReButton{
                width: 1.3rem;
                height: 0.2rem;
                background-color: #9797ff;
                color: #fff;
                font-size: $TextSize;
                margin: 0.3rem auto 0;
                border-radius: 0.2rem;
                cursor: pointer;
            }
          .CodeWrap{
              width: 1.3rem;
              height: 1.3rem;
              background-color: #fff;
              margin: 0.3rem auto 0.1rem;
              border: 0.02rem solid #fff;
              img{
                  width: 100%;
                  height: 100%;
              }
          }
            .Tip{
                width: 100%;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    margin: 0 0.03rem;
                }
                p:last-child{
                    font-size: $TextSize;
                    font-weight: bold;
                    color: #ceceff;
                }
            }
        }
        .SwiperWrap {
            width: 89%;
            height: 1.3rem;
            position: relative;
            overflow: hidden;
            margin: 0 auto;
            .swiper-pagination {
                width: 100%;
                height: 0.1rem;
                position: absolute;
                bottom: 0.02rem;
                ::v-deep .swiper-pagination-bullet-active {
                    background-color: #fff !important;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 0.15rem;
                    height: 0.02rem;
                    opacity: 1;
                    margin: 0 0.02rem;
                    background-color: #4d4d4d;
                    border-radius: 0.03rem;
                }
            }

            .LeftShadow, .RightShadow {
                height: 100%;
                position: absolute;
                z-index: 2;

                img {
                    height: 100%;
                    transform: scale(1.1);
                }
            }

            .LeftShadow {
                left: -0.1rem;
                top: 0;
            }

            .RightShadow {
                right: -0.1rem;
                top: 0;
            }

            .SwiperList {
                width: 100%;
                height: 100%;

                .ImgWrap {
                    border-radius: 0.1rem;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.1rem;
                    }
                }
            }
        }
        .LineCut{
            width: 88%;
            margin: 0.2rem auto 0.15rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .bg{
            width: 100%;
            img{
                width: 87.5%;
                margin: 0 auto;
            }
        }
        .JoinWrap{
            position: relative;
            .Button{
                height: 0.12rem;
                width: 0.4rem;
                border-radius: 0.1rem;
                background-color: #fff;
                color: #336699;
                position: absolute;
                left: 0.15rem;
                bottom: 0.1rem;
                font-size: $SmallTextSize;
                font-weight: bold;
                cursor: pointer;
            }
            .Text{
                width: 1.45rem;
                position: absolute;
                left: 0.15rem;
                top: 0.1rem;
                p:first-child{
                    font-size: $TitleSize;
                    color: #fff;
                    margin-bottom: 0.05rem;
                }
                p:last-child{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
            }
            width: 88%;
            height: 0.65rem;
            margin: 0.15rem auto;
            background-image: url("../../assets/Home/k7.jpg");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            border-radius: 0.1rem;
        }
        .NewsWrap{
            width: 88%;
            margin: 0.2rem auto 0;
            .MoreNews{
                width: 100%;
                border-top: 2px solid #fff;
                box-sizing: border-box;
                margin-top: 0.055rem;
                p{
                    text-align: right;
                    font-size: $TitleSize;
                    color: #fff;
                    padding: 0.03rem 0;
                    cursor: pointer;
                }
            }
            .NewsImg{
                width: 1.3rem;
                height: 1.01rem;
                border-radius:0.1rem;
                cursor: pointer;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius:0.1rem;
                }
            }
            .NewsList{
                width: 1.8rem;
                .ListWrap{
                    height: 0.75rem;
                    overflow: scroll;
                    &::-webkit-scrollbar{
                        display: none;
                    }
                }
                ul{
                    width: 100%;
                    li{
                        width: 100%;
                        margin-top: 0.055rem;
                        cursor: pointer;
                        p{
                            font-size: $AdditionTextSize;
                            color: #fff;
                        }
                        p:first-child{
                            width: 60%;
                        }
                        p:last-child{
                            font-size: $SmallTextSize;
                            opacity: 0.6;
                        }
                    }
                }
                .NewsTitle{
                    width: 100%;
                    border-bottom: 2px solid #fff;
                    p{
                        font-size: $TitleSize;
                        color: #fff;
                        padding-bottom: 0.045rem;
                        span{
                            opacity: 0.6;
                            font-weight: normal;
                        }
                    }
                }
            }

        }
/*        .ReadWrap{
            width: 88%;
            margin: 0 auto;
            height: 2.3rem;
            background-color: #2d2d2d;
            border-radius: 0.1rem;
            .ListContent{
                margin: 0 auto;
                ul{
                    width: 100%;
                    margin-top: 0.05rem;
                    li{
                        width: 100%;
                        height: 0.125rem;
                        cursor: pointer;
                        p{
                            font-size: $TextSize;
                            color: #fff;
                        }
                        p:last-child{
                            font-size: $AdditionTextSize;
                            color: #fff;
                            opacity: 0.6;
                        }
                    }
                }
            }
            .MoreWrap{
                width: 100%;
                height: 1rem;
                margin-top: 0.07rem;
                .ListContent{
                    width: 100%;
                    margin-top: 0.07rem;
                }
                .LeftContent{
                    width: 43%;
                    height: 1rem;
                    margin-left: 0.07rem;
                }
                .RightContent{
                    width: 43%;
                    height: 1rem;
                    margin-right: 0.07rem;
                }
                .LeftContent,.RightContent{
                    .Title{
                        width: 100%;
                        border-bottom: 4px solid #fff;
                        padding-bottom: 0.04rem;
                        div{
                            img{
                                height: 0.06rem;
                                margin-right: 0.02rem;
                            }
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                            }
                        }
                    }
                }
            }
            .VedioWrap{
                width: 100%;
                height: 1.1rem;
                padding-top: 0.06rem;
                .Vedio{
                    width: 55%;
                    height: 1.1rem;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .VedioList{
                    width: 45%;
                    height: 1.1rem;
                    background-color: #000000;
                    position: relative;
                    .ListContent{
                        width: 90%;
                    }
                    .Page{
                        width: 100%;
                        height: 0.1rem;
                        background-color: #1a1a1a;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        .PageNum{
                            position: absolute;
                            right: 0.075rem;
                            .LastPage{
                                margin-right: 0.05rem;
                                opacity: 0.8;
                            }
                            .NextPage{
                                margin-left: 0.05rem;
                                opacity: 0.8;
                            }
                            div{
                                color: #fff;
                                font-size: $AdditionTextSize;
                                cursor: pointer;
                                span{
                                    font-size: $TextSize;
                                    margin: 0 0.04rem;
                                    opacity: 0.6;
                                }
                                span.active{
                                    opacity: 1;
                                }
                            }
                        }
                    }
                    .ListNav{
                        width: 90%;
                        margin: 0 auto;
                        height: 0.18rem;
                        .nav1,.nav2,.nav3{
                            width: 33.333%;
                            height: 0.18rem;
                            opacity: 0.6;
                            cursor: pointer;
                            position: relative;
                            img{
                                height: 0.06rem;
                                margin-right: 0.02rem;
                            }
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                            }
                        }
                        .nav3{
                            div{
                                position: absolute;
                                right: 0;
                            }
                        }
                        div.active{
                            opacity: 1;
                        }
                    }
                }

            }
        }*/
    }
</style>
